<script setup lang="ts">
import { onMounted } from 'vue';

import ErrorBoundary from '@/components/ErrorBoundary.vue';
import Loading from '@/components/loading.vue';
import TeamDialogManager from '@/components/team-dialog/TeamDialogManager.vue';
import { Toaster } from '@/components/ui/sonner';
import { useDynamicVh } from '@/composables/useDynamicVh';
import { useAuthStore } from '@/stores/auth';
import { useOrganizationStore } from '@/stores/organization';

// Initialize dynamic viewport height for iOS Safari/Chrome fix
useDynamicVh();

const authStore = useAuthStore();
const organizationStore = useOrganizationStore();

onMounted(async () => {
  // Load user data if there's a stored token
  await authStore.loadUserFromToken();

  // Load organizations if user is logged in
  // The fetchingMemberships flag in auth store prevents duplicate API calls
  if (authStore.isLogin) {
    await organizationStore.loadUserOrganizations();
  }
});
</script>

<template>
  <Toaster />
  <!-- <VueQueryDevtools /> -->

  <!-- Global Team Dialog Manager - renders dialogs at app root level for mobile compatibility -->
  <TeamDialogManager />

  <ErrorBoundary>
    <Suspense>
      <router-view v-slot="{ Component, route }">
        <component :is="Component" :key="route.name" />
      </router-view>

      <template #fallback>
        <Loading />
      </template>
    </Suspense>
  </ErrorBoundary>
</template>
